<template>
  <pt-customer-manage class="pt-customer-manage__withData" @deleteCustomer="deleteCustomer" ref="table"></pt-customer-manage>
</template>

<script>
import PtCustomerManage from './index'
export default {
  name: 'pt-customer-manage__withData',
  components: {
    'pt-customer-manage': PtCustomerManage
  },
  methods: {
    deleteCustomer (id) {
      this.$store.dispatch('deleteVendor', id).then(res => {
        this.$message.success('删除客户成功')
        this.$refs.table.reload()
      }).catch(err => {
        this.$message.error(err || '删除客户失败')
      })
    }
  }
}
</script>
